import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { Errors } from '../style';
import { TableComponentProps } from '../types';
import { idCreator } from '../../../../../Project/utils/idCreator';

const columnLables = {
  aifm_identifier_lei: {
    name: 'AIFM LEI Code',
    order: 22
  },
  aifm_identifier_bic: {
    name: 'AIFM BIC Code',
    order: 23
  },
  old_reporting_member_state: {
    name: 'Old AIFM national identifier - Reporting Member State',
    order: 24
  },
  old_aifm_national_code: {
    name: 'Old AIFM national identifier - National code',
    order: 25
  }
};

export const FundIdentificationCodes4AIF001 = ({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) => {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.AIFM_IDENTIFIERS,
    onChangeFund,
    schema: schema.AIFM_IDENTIFIERS,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.AIFM_IDENTIFIERS?.field_names || [],
    isMultiFunds,
    funds,
    columnLables,
    tableName: 'AIFM_IDENTIFIERS'
  });

  const isRequiredTable =
    funds[currentDataKey]?.required_tables?.AIFM_IDENTIFIERS?.field_names?.length === 0;

  const errors = funds[currentDataKey]?.fund_data?.AIFM_IDENTIFIERS?.find(
    item => item?.errors?.general
  )?.errors?.general;

  return (
    <>
      <Errors id="reporttables-fund-identification-codes-4-aif001-errors">
        {isRequiredTable && (
          <li id="reporttables-fund-identification-codes-4-aif001-required-error">
            This section must be completed
          </li>
        )}
        {errors?.map(item => (
          <li
            key={item.msg}
            id={`reporttables-fund-identification-codes-4-aif001-error-${idCreator(item.msg)}`}
          >
            {item.msg}
          </li>
        ))}
      </Errors>

      <Table
        id="reporttables-fund-identification-codes-4-aif001-table"
        handleChanges={onChange}
        stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
        columns={columns}
        rows={rows}
      />
    </>
  );
};
